import React from 'react';
import './App.css';


import ItemList from './ItemList';

function App({version}) {
  return (
    <div className="App">
      <nav className="navbar navbar-dark bg-primary">
        <span className="navbar-brand">Namely - {version}</span>
      </nav>
      <div className="list-container">
        <ItemList />
      </div>
    </div>
  );
}

export default App;
